export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=7033015a0486daf65914f870b528bb55bb96e9c65d&name=pushAdClickData!'